import { createWorker } from 'tesseract.js'
import { parseReceipt, type ReceiptGuess } from './receipt'

export type ScanResult = ReceiptGuess & {
  imageDataUrl: string
}

const OCR_TIMEOUT_MS = 45_000

function withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = window.setTimeout(() => {
      reject(new Error(`${label} timed out`))
    }, ms)
    promise
      .then((value) => {
        window.clearTimeout(timer)
        resolve(value)
      })
      .catch((error) => {
        window.clearTimeout(timer)
        reject(error)
      })
  })
}

export async function recognizeReceipt(imageDataUrl: string): Promise<ScanResult> {
  return withTimeout(runOcr(imageDataUrl), OCR_TIMEOUT_MS, 'Receipt scan')
}

async function runOcr(imageDataUrl: string): Promise<ScanResult> {
  const worker = await createWorker('eng', 1, {
    logger: () => undefined,
  })
  try {
    const { data } = await worker.recognize(imageDataUrl)
    return {
      imageDataUrl,
      ...parseReceipt(data.text ?? ''),
    }
  } finally {
    await worker.terminate()
  }
}
